export function getLocalStorage(key: string): string | null {
  try {
    const item = window.localStorage.getItem(key);
    return item;
  } catch {
    return null;
  }
}

export function setLocalStorage(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // handle error if needed
  }
}

export function deleteLocalStorage(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // handle error if needed
  }
}

export function clearLocalStorages(): void {
  try {
    window.localStorage.clear();
  } catch {
    // handle error if needed
  }
}